import React from  'react';
import classnames from 'classnames';

const STOKE_DASH_ARRAY = 1130;

export default ({ score, width, height }) => {
  const strokeClasses = { 'stroke-fill': true};
  if(score <= 50){
    strokeClasses.poor = true;
  }else if (score <= 70){
    strokeClasses.neutral = true;
  }else{
    strokeClasses.excellent = true;
  }
  return (
    <div style={{position: 'relative', width: width || '200px', height: height || '200px' }}>
      <svg width={width || "200"} height={height || "200"}  viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
        <g>
          <circle className="stroke-bg" cx="200" cy="200" r="180" />
          <circle className={classnames(strokeClasses)} cx="200" cy="200" r="180" transform="rotate(-90 200 200)" strokeDasharray={STOKE_DASH_ARRAY} strokeDashoffset={STOKE_DASH_ARRAY - (STOKE_DASH_ARRAY * score * .01)} />
          <text className="text-lg" x="200" y="160" fontWeight="bold" textAnchor="middle" alignmentBaseline="central">
            {score}
          </text>
          <text className="text-sm" x="200" y="250" fontSize="35" textAnchor="middle">OUT OF 100</text>
        </g>
      </svg>
    </div>
  );
}

